import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAccessToken } from '../../components/common/hooks/useAccessToken';
import { isAdminSelector } from '../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../components/store/common/slice';
import { changeSearchResults } from '../../components/store/admin/slice';
import { constants } from '../../components/common/constants/constants';
import SearchForm from './SearchForm/SearchForm';

const SearchPaymentPlan = () => {
    const dispatch = useDispatch();
    const client = useAccessToken();
    const isAdmin = useSelector(isAdminSelector);
    const { t } = useTranslation();

    const history = useHistory();

    const onSearchClick = async (e, inputValues) => {
        dispatch(showLoader());

        e.preventDefault();      
        let response = await client.post('/operations/search-plans/', inputValues);
        if (response) {
            dispatch(changeSearchResults(response));
            history.push({
                pathname: `${constants.pages.admin.searchPaymentsUrl}/resultTable`
            });
        }

        dispatch(hideLoader());
    };

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return <SearchForm client={client} onSearchClick={onSearchClick} />;
};

export default SearchPaymentPlan;
